export function keyArrayToRecord<T>(arr: T[], keySelector: (obj: T) => string): Record<string, T> {
    return arr.reduce((prev, curr) => ({ ...prev, [keySelector(curr)]: curr }), {});
}
